import * as React from "react";
import DeviceContext from "../../../service/indentifyDevice";
import "../../../../assets/scss/components/toc/orderPlacement/opGenerateMandate/opGenerateMandateDsk.scss";
import "../../../../assets/scss/components/toc/orderPlacement/opGenerateMandate/opGenerateMandateTab.scss";
import "../../../../assets/scss/components/toc/orderPlacement/opGenerateMandate/opGenerateMandateMob.scss";

export interface IOpGenerateMandateProps {
	companyName: string;
	contentArr: Array<IOpGenerateMandateContent>; // the array of field value data to show in the middle
	onEdit: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export interface IOpGenerateMandateContent {
	label: string;
	value: string;
}

const OpGenerateMandate: React.FC<IOpGenerateMandateProps> = props => {
	return (
		<div className="op_mf_generate_mandate">
			<div className="header_outer">
				<div className="header_inner">
					<div className="your_order">Your Order</div>
					<h2 className="comp_name">{props.companyName}</h2>
				</div>
				{!DeviceContext().isDesktop && (
					<div className="edit_cont">
						<button className="edit_btn" onClick={props.onEdit}>
							Edit
						</button>
					</div>
				)}
			</div>
			<div className="info">
				{props.contentArr.map(content => (
					<div className="row" key={content.label}>
						<div className="label ib">{content.label}</div>
						<div className="value ib">{content.value}</div>
					</div>
				))}
			</div>
			{DeviceContext().isDesktop && (
				<div className="edit_cont">
					<button className="edit_btn" onClick={props.onEdit}>
						Edit
					</button>
				</div>
			)}
		</div>
	);
};

export default OpGenerateMandate;
